import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiButton } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';

import { PageNotFoundComponent } from './page-not-found.component';

@NgModule({
  declarations: [PageNotFoundComponent],
  imports: [CommonModule, RouterModule, TuiButton, TranslateModule],
  exports: [PageNotFoundComponent],
})
export class PageNotFoundModule {}
